import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Container, Header, Form, Button } from 'semantic-ui-react';
import { Formik, Field, Form as FormikForm } from 'formik';
import { FormikInputComponent } from '../../../utilities/formUtils';
import userACL from '../../../store/access'
import { getFilteredSegmap } from '../data/selectors';
import { modifyCashBankMapForClone } from './commomFunctions';


const CashBankMapCloneBySegid = ({ setCloneModal, setFieldValue }) => {

    const segmapData = useSelector(state => getFilteredSegmap(state))

    let InitialVal = { segid: "", loc_cd: "" }


    const searchBySegid = (values, resetForm) => {
        let segid = values.segid
        let loc = values.loc_cd
        segmapData.filter((item) => {
            if (item.loc_cd == loc && item.segid == segid) {
                let cashBankObject = (item && item.cash_bank_map !== null && item.cash_bank_map !== undefined) ? item.cash_bank_map : ""
                let cashBankMap = modifyCashBankMapForClone(cashBankObject)
                // console.log('cashBankMap', cashBankMap)
                setFieldValue("cash_bank_map", cashBankMap)
                return item
            }
        })
        setCloneModal({ open: false, msg: "" })
    }


    return (
        <>
            <Formik id="cloneForm" size="large" width={5}
                initialValues={InitialVal}
                validationSchema={null}
                onSubmit={(values, { resetForm }) => searchBySegid(values, resetForm)}
                render={({ handleSubmit, resetForm, onChange, values, handleChange }) => (
                    <Form as={FormikForm} size="small" className="CustomeF" width={5} onSubmit={handleSubmit}>
                        <Form.Group widths={2}>
                            <Field name="segid" component={FormikInputComponent} placeholder="SEGID"></Field>
                            <Field name="loc_cd" component={FormikInputComponent} placeholder="LOC CD"></Field>
                        </Form.Group>
                        <Button type="button" size="medium blue" className="CustomeBTN" onClick={() => searchBySegid(values)}>Search</Button>
                    </Form>
                )}
            />
        </>
    )
}

export default CashBankMapCloneBySegid